import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {
	HttpBackend,
	HttpClient,
	HttpClientModule
} from '@angular/common/http';
import { AppRoutingModule, appRoutes } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { GlobalConstants } from '@shared/utils/global-constants';
import { GlobalConfigService } from '@shared/utils/global-config.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {
	RouteReuseStrategy,
	provideRouter,
	withComponentInputBinding
} from '@angular/router';
import { MicroFrontendRouteReuseStrategy } from 'src/app/spa-host/single-spa-service/route-reuse-strategy';
import { HarnessService } from '@shared/services/harness-service/harness-service';

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpHandler: HttpBackend) {
	return new TranslateHttpLoader(new HttpClient(httpHandler), GlobalConstants.TRANSLATION_LANG_PATH, '.json');
}
export function initializeHarnessService(harnessService: HarnessService): () => Promise<void> { 
	return () => harnessService.initialize();
}

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule,
		AppRoutingModule,
		HttpClientModule,
		TranslateModule.forRoot({
			defaultLanguage: GlobalConstants.LANGUAGES.EN,
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpBackend]
			}
		}),
		CoreModule,
		NgbModule
	],
	providers: [
		{
			provide: APP_INITIALIZER,
			useFactory: preloadFactory,
			deps: [GlobalConfigService],
			multi: true
		},
		HarnessService,
		{ 
			provide: APP_INITIALIZER,
			useFactory: initializeHarnessService,
			deps: [HarnessService],
			multi: true 
		},
		{
			provide: 'Window',
			useValue: window
		},
		{
			provide: RouteReuseStrategy,
			useClass: MicroFrontendRouteReuseStrategy
		},
		provideRouter(appRoutes, withComponentInputBinding())
	],
	bootstrap: [AppComponent]
})
export class AppModule {}

export function preloadFactory(provider: GlobalConfigService) {
	return () => provider.init();
}
